import { checkCombiningTask } from '../../DocFlowCombining'

import {
  USE_LOAD_DOCUMENT_STAPLING_COMBINING_PHASE_ASYNC_STATUS_SUCCESS,
  USE_LOAD_DOCUMENT_STAPLING_COMBINING_PHASE_ASYNC_TIME_OUT,
} from './useLoadCombiningPhaseAsync.constants'

export function checkTaskStatus(params) {
  checkCombiningTask(params.task).then(({ data }) => {
    if (data.ready) {
      params.onReadyTask({ ...data, ...params })
    } else {
      setTimeout(
        () => checkTaskStatus(params),
        USE_LOAD_DOCUMENT_STAPLING_COMBINING_PHASE_ASYNC_TIME_OUT
      )
    }

    params.onReloadProfile()
  })
}

export function isAsyncTaskSuccess(data) {
  return (
    data.status ===
    USE_LOAD_DOCUMENT_STAPLING_COMBINING_PHASE_ASYNC_STATUS_SUCCESS
  )
}
